import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { fetchMoviesWithFallback } from '../utilities/fetchWithFallback';
import { addUpcomingMovies } from '../utilities/movieSlice';

const useUpcomingMovies = () => {
 const dispatch=useDispatch();
 useEffect(()=>{
    const getUpcomingMovies=async()=>{
        const results = await fetchMoviesWithFallback('https://api.themoviedb.org/3/movie/upcoming?language=en-US&page=1', 'upcoming');
        dispatch(addUpcomingMovies(results))
    }
    getUpcomingMovies()
 },[dispatch])
}

export default useUpcomingMovies;